import React from "react";
import { Box, Typography } from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import useCommonStyles from "./style";

const TextBlock = ({ classes, title, text }) =>
  text ? (
    <Box className={classes.cbBlock}>
      <Typography className={classes.cbBlockTitle}>{title}</Typography>
      <Typography className={classes.cbBlockText}>{text}</Typography>
    </Box>
  ) : null;

// One report's food_based_support: the remedy (recommendation) and/or the
// trigger pattern — the chatbot sometimes fills only one, so render whichever
// has content.
const RemedyCard = ({ classes, date, support }) => {
  const recommendation = (support && support.recommendation) || {};
  const trigger = (support && support.trigger_pattern) || {};
  const source =
    recommendation.herbal_reference && recommendation.herbal_reference.source;

  return (
    <Box className={classes.cbRemedyCard}>
      {date && (
        <Typography className={classes.cbRemedyDate}>{date}</Typography>
      )}

      {recommendation.title && (
        <Typography className={classes.pcPrimary}>
          {recommendation.title}
        </Typography>
      )}

      <TextBlock
        classes={classes}
        title="Preparation & Use"
        text={recommendation.preparation}
      />
      <TextBlock
        classes={classes}
        title="Why It Helps"
        text={recommendation.meaning}
      />
      <TextBlock
        classes={classes}
        title="Traditional Note"
        text={recommendation.traditional_note}
      />

      {trigger.description && (
        <TextBlock
          classes={classes}
          title={trigger.title || "Likely Trigger Pattern"}
          text={trigger.description}
        />
      )}

      {source && (
        <Box className={classes.cbBlock}>
          <Typography
            className={classes.pcMetaValue}
            style={{ fontStyle: "italic", color: "#6b7280" }}
          >
            Reference: {source}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

// Short Chatbot Home Remedies (Recommendations): the latest few Symptom Analyzer
// reports' `food_based_support`, each dated, newest first.
const HomeRemedies = ({ remedies }) => {
  const classes = useCommonStyles();
  const list = Array.isArray(remedies) ? remedies : [];

  if (!list.length) {
    return (
      <Box className={classes.hiPlaceholder}>
        <InfoOutlinedIcon className={classes.hiPlaceholderIcon} />
        <Typography className={classes.hiPlaceholderNote}>
          No home remedies available for this patient yet.
        </Typography>
      </Box>
    );
  }

  return (
    <Box className={classes.cbRemedyList}>
      {list.map((entry, i) => (
        <RemedyCard
          key={i}
          classes={classes}
          date={entry.date}
          support={entry.support}
        />
      ))}
    </Box>
  );
};

export default HomeRemedies;
